// @flow

export const styles = {
  title: {
    marginBottom: 28,
    fontFamily: 'TTNorms-Bold',
    fontSize: 24,
    color: '#1F1F1F',
    lineHeight: '36px'
  },
  paragraph: {
    marginBottom: 0,
    fontFamily: 'TTNorms-Regular',
    fontSize: 16,
    color: '#1F1F1F',
    lineHeight: '29px',
    '@media (max-width: 767px)': {
      textAlign: 'left'
    }
  },
  columns2: {
    '-webkit-columns': '2 250px',
    '-moz-columns': '2 250px',
    columns: '2 250px',
    '-webkit-column-gap': '50px',
    '-moz-column-gap': '50px',
    'column-gap': '50px'
  },
  previewList: {
    textAlign: 'center',
    '& img': {
      width: '19.66666%',
      maxWidth: 200,
      cursor: 'pointer'
    }
  },
  summary: {
    '-webkit-columns': '2 250px',
    '-moz-columns': '2 250px',
    columns: '2 250px',
    '& > a': {
      display: 'flex',
      alignItems: 'center',
      lineHeight: '40px',
      marginTop: -1,
      borderTop: '1px solid #E6E7EA',
      borderBottom: '1px solid #E6E7EA',
      textDecoration: 'none',
      color: '#1F1F1F',
      fontSize: 16,
      fontFamily: 'TTNorms-Regular',
      transition: 'color .2s ease-in-out',
      '&:before': {
        content: '""',
        width: 10,
        minWidth: 10,
        height: 10,
        marginRight: 10,
        marginLeft: 6,
        borderRadius: '100%',
        border: '2px solid #0A132C',
        transition: 'background .2s ease-in-out'
      },
      '&:hover': {
        color: '#1F1F1F',
        '&:before': {
          backgroundColor: '#1F1F1F'
        }
      }
    },
    '&:hover': {
      '& > a': {
        color: 'rgba(31,31,31,0.4)',
        '&:before': {
          borderColor: 'rgba(31,31,31,0.4)'
        }
      }
    }
  },
  summaryHeight160: {
    height: 160,
    '@media (max-width: 767px)': {
      height: 'unset'
    }
  },
  progressBar: {
    display: 'flex',
    height: 56,
    alignItems: 'stretch',
    '@media (max-width: 767px)': {
      height: 45
    }
  },
  progressBarShadow: {
    display: 'flex',
    height: 56,
    marginTop: -50,
    zIndex: -1,
    alignItems: 'stretch',
    filter: 'blur(10px)',
    opacity: 0.5,
    '@media (max-width: 767px)': {
      height: 45,
      marginTop: -35
    }
  },
  legend: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 30,
    marginBottom: 40,
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      width: '33.3333%',
      paddingRight: 10,
      marginBottom: 20,
      fontSize: 16,
      color: '#1F1F1F',
      lineHeight: '20px',
      '& > i': {
        display: 'inline-block',
        width: 20,
        minWidth: 20,
        height: 20,
        marginRight: 10
      }
    },
    '@media (max-width: 767px)': {
      '& > div': {
        width: '50%',
        minWidth: 290
      }
    },
    '@media (max-width: 719px)': {
      '& > div': {
        width: '100%',
        minWidth: 'unset'
      }
    }
  },
  quote: {
    alignSelf: 'center',
    paddingLeft: 20,
    marginBottom: 0,
    fontFamily: 'TTNorms-Bold',
    fontSize: 20,
    color: '#1F1F1F',
    textAlign: 'right',
    lineHeight: '32px',
    '& mark': {
      padding: '3px 0',
      backgroundColor: '#FFF194'
    },
    '@media (max-width: 719px)': {
      textAlign: 'left',
      paddingLeft: 5,
      marginTop: 28,
      marginBottom: 28,
      order: 3
    }
  },
  quoteBlock: {
    textAlign: 'left',
    paddingLeft: 9,
    marginTop: 28,
    marginBottom: 28,
    order: 3,
    '@media (max-width: 719px)': {
      paddingLeft: 5
    }
  },
  teamMember: {
    width: 180,
    height: 64,
    paddingLeft: 16,
    marginRight: 8,
    marginBottom: 8,
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #E6E7EA',
    borderRadius: 4,
    fontSize: 12,
    color: '#1F1F1F',
    lineHeight: '15px',
    '& img': {
      display: 'inline-block',
      marginRight: 8,
      marginBottom: 0,
      width: 32,
      height: 32
    },
    '& i': {
      backgroundColor: 'transparent',
      borderRadius: 100,
      border: '1px solid #000000',
      minWidth: 8,
      height: 8,
      marginRight: 10
    }
  },
  team: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  // team: {
  //   alignSelf: 'flex-start',
  //   marginTop: -100,
  //   paddingRight: 0,
  //   paddingLeft: 0,
  //   backgroundColor: 'white',
  //   border: '1px solid #E6E7EA',
  //   boxShadow: '0 10px 30px 0 rgba(10,19,44,0.12)',
  //   borderRadius: 5,
  //   '& > *': {
  //     paddingLeft: 35,
  //     paddingRight: 35
  //   },
  //   '& img': {
  //     display: 'inline-block',
  //     marginRight: 8,
  //     marginBottom: 0,
  //     width: 26,
  //     height: 26,
  //     backgroundColor: 'black',
  //     borderRadius: 4
  //   },
  //   '& > $title': {
  //     marginTop: 35,
  //     marginBottom: 35
  //   },
  //   '& > $paragraph': {
  //     display: 'flex',
  //     alignItems: 'center',
  //     marginTop: 10,
  //     marginBottom: 10,
  //     textAlign: 'left',
  //     '&:last-child': {
  //       marginTop: 30,
  //       marginBottom: 30
  //     }
  //   },
  //   '@media (max-width: 767px)': {
  //     marginTop: 30
  //   }
  // },
  separator: {
    width: '100%',
    height: 1,
    background: '#E6E7EA'
  },
  highlight: {
    display: 'flex',
    flexWrap: 'wrap',
    minHeight: 80,
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: 90,
      minWidth: 90,
      minHeight: 80,
      marginRight: 20,
      marginBottom: 20,
      fontSize: 12,
      textAlign: 'center',
      fontFamily: 'TTNorms-Regular',
      backgroundColor: '#FFF194',
      '& > strong': {
        display: 'block',
        marginBottom: -8,
        fontFamily: 'TTNorms-Medium',
        fontSize: 16
      }
    }
  },
  image: {
    border: '1px solid #1F1F1F',
    marginBottom: 0
  },
  shadow: {
    boxShadow: '-39px 36px 85px rgba(0,0,0,.06)'
  },
  // blueNote: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   padding: 20,
  //   marginTop: -110,
  //   backgroundColor: '#0A132C',
  //   color: 'white',
  //   fontSize: 12,
  //   fontFamily: 'TTNorms-Regular',
  //   lineHeight: '18px',
  //   '& > i': {
  //     fontSize: 18,
  //     marginRight: 16
  //   },
  //   '@media (max-width: 767px)': {
  //     marginTop: -50
  //   }
  // },
  lightSection: {
    paddingBottom: 150,
    backgroundColor: '#EDEDED'
  },
  // blackParagraph: {
  //   paddingTop: 76,
  //   paddingBottom: 76,
  //   backgroundColor: '#141414',
  //   color: 'white',
  //   '& $title': {
  //     color: 'white'
  //   },
  //   '& $paragraph': {
  //     color: 'white'
  //   },
  //   '& $image': {
  //     borderColor: 'white'
  //   }
  // },
  test: {
    '& $paragraph': {
      marginBottom: 40
    }
  },
  sideImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& $image': {
      marginBottom: 0
    },
    '@media (max-width: 767px)': {
      order: 2
    }
  },
  colorPalette: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > div': {
      marginRight: 40,
      marginBottom: 20,
      '@media (max-width: 767px)': {
        marginRight: 10
      }
    },
    '& p': {
      marginBottom: 0,
      fontSize: 16,
      textAlign: 'center',
      lineHeight: '29px',
      '@media (max-width: 767px)': {
        fontSize: 12,
        lineHeight: '16px'
      }
    }
  },
  colorSwatch: {
    width: 145,
    height: 110,
    border: '10px solid rgba(255,255,255,0.40)',
    '@media (max-width: 767px)': {
      width: 100,
      height: 80
    }
  },
  annotedImage: {
    display: 'flex'
  },
  annotation: {
    position: 'relative',
    '& div': {
      position: 'absolute',
      padding: '3px 0',
      '& p': {
        margin: 0,
        fontSize: 16,
        color: '#1F1F1F',
        textAlign: 'right',
        fontFamily: 'TTNorms-Regular',
        lineHeight: '22px'
      },
      '& h6': {
        margin: 0,
        fontSize: 16,
        color: '#1F1F1F',
        textAlign: 'right',
        fontFamily: 'TTNorms-Bold',
        lineHeight: '22px'
      }
    }
  },
  floatingImage: {
    overflow: 'hidden',
    '& img': {
      maxWidth: '100%'
    }
  },
  next: {
    paddingTop: 80,
    paddingBottom: 80,
    backgroundColor: '#E7E7E7',
    '& > h2': {
      marginTop: 20,
      fontSize: 24,
      color: '#1F1F1F',
      lineHeight: '36px'
    }
  },
  link: {
    padding: '10px 0',
    display: 'block',
    textDecoration: 'none',
    '& h2': {
      margin: 0,
      fontSize: 16,
      color: '#1F1F1F'
    },
    '& p': {
      margin: '2px 0 0 0',
      fontSize: 12,
      lineHeight: '15px',
      color: '#707070'
    }
  },
  leftLine: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 60,
    '&:before': {
      content: '" "',
      minWidth: 3,
      width: 3,
      alignSelf: 'normal',
      borderRadius: 4,
      marginRight: 17,
      backgroundColor: '#4A474C',
      boxShadow: '0 2px 4px 0 rgba(74,71,76,0.50)'
    }
  },
  blueLine: {
    '&:before': {
      backgroundColor: '#4DA0E6',
      boxShadow: '0 2px 4px 0 rgba(77,160,230,0.50)'
    }
  },
  purpleLine: {
    '&:before': {
      backgroundColor: '#9E2CDE',
      boxShadow: '0 2px 4px 0 rgba(158,44,222,0.50)'
    }
  },
  greenLine: {
    '&:before': {
      backgroundColor: '#38DD9F',
      boxShadow: '0 2px 4px 0 rgba(56,221,159,0.50)'
    }
  },
  noBorder: {
    border: 'none'
  },
  smallText: {
    fontSize: 12,
    lineHeight: '16px'
  },
  marginTop240: {
    marginTop: 240
  },
  marginTop130: {
    marginTop: 130
  },
  marginTop100: {
    marginTop: 100
  },
  marginTop90: {
    marginTop: 90
  },
  marginTop80: {
    marginTop: 80
  },
  marginTop70: {
    marginTop: 70
  },
  marginTop60: {
    marginTop: 60
  },
  marginTop50: {
    marginTop: 50
  },
  marginTop30: {
    marginTop: 30
  },
  marginTop20: {
    marginTop: 20
  },
  paddingTop60: {
    paddingTop: 60
  },
  paddingBottom100: {
    paddingBottom: 100
  },
  marginLeftNeg90: {
    marginLeft: -90
  }
}



// WEBPACK FOOTER //
// ./src/Styles/CaseStudy.Style.js